module.exports = __webpack_public_path__ + "media/2_2-9.0ded3967.mp3";